<tudi-menu></tudi-menu>
<div class="constraint-area">
  <div *ngIf="!selectedTongue">
    <button pButton label="Select Tongue" (click)="startSelectTongue()"></button>
  </div>
  <div *ngIf="selectedTongue">
    <img [src]="selectedTongue.imageUrl" alt="{{selectedTongue.name}}" [title]="selectedTongue.name" (click)="startSelectTongue()">
  </div>
  <div class="is-match-area">
    <div>
      <p-radioButton name="isMatch" value="1" [(ngModel)]="isMatch" inputId="isMatch1"></p-radioButton>
      <label for="isMatch1" class="ml-2">
        Match
      </label>
    </div>
    <div>
      <p-radioButton name="isMatch" value="0" [(ngModel)]="isMatch" inputId="isMatch2"></p-radioButton>
      <label for="isMatch2" class="ml-2">
        Filter
      </label>
    </div>
    <div>
      <p-radioButton name="isMatch" value="2" [(ngModel)]="isMatch" inputId="isMatch3"></p-radioButton>
      <label for="isMatch3" class="ml-2">
        All
      </label>
    </div>
    <div class="flex align-items-center ml-4 border-left-1 border-300 pl-4">
      <span class="mr-2">Sort:</span>
      <div class="flex align-items-center">
        <p-radioButton name="sortOrder" [value]="1" [(ngModel)]="sort" inputId="olderFirst"></p-radioButton>
        <label for="olderFirst" class="ml-2">older first</label>
      </div>
      <div class="flex align-items-center ml-2">
        <p-radioButton name="sortOrder" [value]="2" [(ngModel)]="sort" inputId="newerFirst"></p-radioButton>
        <label for="newerFirst" class="ml-2">newer first</label>
      </div>
    </div>
  </div>
</div>
<div class="tongue-data-area" *ngIf="tongueData">
  <p-scrollPanel [style]="{ width: '100%', height: '200px' }">
    <ng-container *ngIf="tongueData.type === 2">
      <ng-container *ngFor="let diagnosis of tongueData.diagnosisList">
        <p class="location-title">Location: {{diagnosis.location | tongueLocation}}</p>
        <p><strong>Pattern:</strong> {{diagnosis.pattern}}</p>
        <p><strong>Symptoms of Males:</strong> {{diagnosis.symptomsMale}}</p>
        <p><strong>Symptoms of Females:</strong> {{diagnosis.symptomsFemale}}</p>
        <p><strong>Recommendation:</strong> {{diagnosis.recommendation}}</p>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="tongueData.type !== 2">
      <p><strong>Pattern:</strong> {{tongueData.diagnosisList[0].pattern}}</p>
      <p><strong>Symptoms of Males:</strong> {{tongueData.diagnosisList[0].symptomsMale}}</p>
      <p><strong>Symptoms of Females:</strong> {{tongueData.diagnosisList[0].symptomsFemale}}</p>
      <p><strong>Recommendation:</strong> {{tongueData.diagnosisList[0].recommendation}}</p>
    </ng-container>
  </p-scrollPanel>
</div>
<div class="search-button-area">
  <button pButton label="search" (click)="search()"></button>
</div>
<div class="case-list-area" *ngIf="cases.length > 0">
  <ng-container *ngTemplateOutlet="pagination"></ng-container>
  
  <div *ngFor="let patientCase of cases; let i = index" class="case-area" [id]="'case-' + i" [class.active-case]="i === activeIndex">
    <div class="case-title">Case {{patientCase.caseId}} in {{patientCase.createTime}}</div>
    <div class="case-data-area">
      <div class="case-image-area">
        <img [src]="patientCase.imageUrl">
        <div class="flex gap-4 p-2 justify-content-center">
          <div class="flex align-items-center">
            <p-radioButton [name]="'isTagged_' + patientCase.caseId" [value]="1" [ngModel]="patientCase.isTagged"
              (ngModelChange)="changeIsTagged(patientCase, 1)" [inputId]="'yes_' + patientCase.caseId"></p-radioButton>
            <label [for]="'yes_' + patientCase.caseId" class="ml-2">Yes</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton [name]="'isTagged_' + patientCase.caseId" [value]="0" [ngModel]="patientCase.isTagged"
              (ngModelChange)="changeIsTagged(patientCase, 0)" [inputId]="'no_' + patientCase.caseId"></p-radioButton>
            <label [for]="'no_' + patientCase.caseId" class="ml-2">No</label>
          </div>
        </div>
      </div>
      <div class="case-description-area">
        <div><strong>Case ID: </strong>{{patientCase.caseId}}</div>
        <div><strong>Create Time: </strong>{{patientCase.createTime}}</div>
        <div><strong>Name: </strong>{{patientCase.name}}</div>
        <div><strong>Doctor: </strong>{{patientCase.doctor?.name}}</div>
        <div><strong>Symptom: </strong>{{patientCase.symptom}}</div>
        <div><strong>Tagger: </strong>{{getTaggerStr(patientCase)}}</div>
      </div>
    </div>
  </div>

  <ng-container *ngTemplateOutlet="pagination"></ng-container>
</div>
<app-tongue-select-dialog [tongues]="tongues" (select)="selectTongue($event)"></app-tongue-select-dialog>

<ng-template #pagination>
  <div class="pagination-container" *ngIf="totalPages > 1">
    <div class="jump-page-area">
      <input type="number" [(ngModel)]="jumpPage" (keydown.enter)="onJumpPageEnter()" placeholder="Page..." class="jump-input">
    </div>
    <button (click)="onPageClick(0)" [disabled]="pageNumber === 0" title="First Page">&lt;&lt;</button>
    <button (click)="onPageClick(pageNumber - 1)" [disabled]="pageNumber === 0" title="Previous Page">&lt;</button>
    <div class="page-numbers">
      <div 
        *ngFor="let page of pages" 
        class="page-item" 
        [class.active]="page === pageNumber"
        (click)="onPageClick(page)">
        {{page + 1}}
      </div>
    </div>
    <button (click)="onPageClick(pageNumber + 1)" [disabled]="pageNumber === totalPages - 1" title="Next Page">&gt;</button>
    <button (click)="onPageClick(totalPages - 1)" [disabled]="pageNumber === totalPages - 1" title="Last Page">&gt;&gt;</button>
  </div>
</ng-template>
